import { CurrencyPipe } from '@angular/common';
import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';

export function formatLocaleCurrency(locale: string, value: number, digitsInfo = '1.0-0'): string | null {
  const currencyCode: string = 'CZK';
  return new CurrencyPipe(locale).transform(value, currencyCode, 'symbol-narrow', digitsInfo);
}

@Pipe({
  name: 'localeCurrency',
  standalone: false,
})
export class LocaleCurrencyPipe implements PipeTransform {
  protected locale = inject(LOCALE_ID);

  transform(value: number, digitsInfo = '1.0-0'): string | null {
    return formatLocaleCurrency(this.locale, value, digitsInfo);
  }
}
